// Métodos de pago que no computan en el importe facturado de "Facturación y estadísticas":
// - 'Pago en sucursal App': la venta real se registra al cobrar en sucursal (EX-441).
// - 'Ingreso de monedero': valor histórico de BD; suma con desglose 0 y duplica la
//   facturación cuando el monedero se gasta (EX-575).
export const METODOS_PAGO_EXCLUIDOS_FACTURACION = [
    'Pago en sucursal App',
    'Ingreso de monedero',
];

// EX-581: producto de catálogo con el que el negocio registra en caja un ingreso al
// monedero del cliente (venta POS con metodoPago normal, p. ej. 'Pago en efectivo', y una
// línea de producto a precio 0). Es un prepago, no un ingreso: la facturación real se
// reconoce cuando el saldo se gasta, así que la recarga no debe computar (evita el mismo
// doble conteo que las de metodoPago 'Ingreso de monedero').
export const PRODUCTO_INGRESO_MONEDERO = 'Ingreso de monedero';

// EX-581: una recarga de monedero registrada como producto es una venta cuya única línea es
// el producto 'Ingreso de monedero' (sin servicios). El guard de "sin servicios" evita
// excluir por error un ticket mixto (servicio real + recarga en la misma venta).
const esRecargaMonederoPorProducto = (venta) => {
    const productos = venta?.productos;
    if (!Array.isArray(productos)) return false;
    const tieneLineaIngresoMonedero = productos.some(
        (producto) => producto?.titulo === PRODUCTO_INGRESO_MONEDERO
    );
    const sinServicios = !Array.isArray(venta?.servicios) || venta.servicios.length === 0;
    return tieneLineaIngresoMonedero && sinServicios;
};

const esVentaFacturable = (venta) =>
    !METODOS_PAGO_EXCLUIDOS_FACTURACION.includes(venta.metodoPago) &&
    !esRecargaMonederoPorProducto(venta);

export const filtrarVentasFacturables = (ventas) =>
    (ventas || []).filter(esVentaFacturable);

// EX-572: compone la fila del contra-asiento para insertarla en el listado de Facturación tras
// anular una venta, sin re-consultar todo el rango de fechas. Hereda de la venta original los
// datos ya poblados (cliente, profesional, sucursal, líneas de servicio/variante/producto) y
// toma del backend la identidad y el desglose ya calculado de la venta de anulación (importe e
// importeServicios/Productos/Descuentos con signo negativo). La fila resultante es equivalente
// a la que devolvería un refetch de `POST /api/ventas/empresa/:id`.
export const componerFilaAnulacion = (ventaOriginal, ventaAnulacion) => ({
    ...ventaOriginal,
    _id: ventaAnulacion._id,
    metodoPago: ventaAnulacion.metodoPago,
    importe: ventaAnulacion.importe,
    importeServicios: ventaAnulacion.importeServicios,
    importeProductos: ventaAnulacion.importeProductos,
    importeDescuentos: ventaAnulacion.importeDescuentos,
    fechaVenta: ventaAnulacion.fechaVenta,
    fechaAnulacion: null,
    anulada: false,
    anulacionRef: undefined,
});
